import actionTypes from '../constants/action-types.js';

const dragSourceElement = (state = null, action) => {
  if (action.type !== actionTypes.SET_SOURCE_ELEMENT) return state;
  return action.payload.elementId;
};

export default dragSourceElement;
